import { Notification, NotificationSize, NotificationType } from '@dreryk/react-components';

import { referralToPsychiatricHospitalTranslationKeys } from '../../../../translations';

export const TwoPagePrintNotification = (): JSX.Element => {
   return (
      <Notification
         testId={'twoPagePrintMessage'}
         size={NotificationSize.SMALLER}
         type={NotificationType.WARNING}
         label={referralToPsychiatricHospitalTranslationKeys.twoPagePrintMessage}
      />
   );
};
